// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zV8G","label":"styles_label__276as"};